import React from 'react';
import { Redirect } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { baseUrl } from '../config/baseUrl';
import useVerifyToken from '../hooks/useVerifyToken';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20%',
  },
}));


const Authentication = (props) => {
  const { children } = props;
  const token = localStorage.getItem('token');
  const { loading, error } = useVerifyToken(token);
  const classes = useStyles();

  if (loading) {
    return (
      <div className={classes.root}>
        <CircularProgress size={80} />
      </div>
    ) 
  }

  if (error) {
    return <Redirect to={`${baseUrl}admin/sign-in`} />;
  }

  return children;
}

const withAuthentication = (Component) =>
  class AuthHOC extends React.Component {
    isAuthenticated = () => Boolean(localStorage.getItem('token'))
    // isAuthenticated = () => true;

    render() {
      if (!this.isAuthenticated()) {
        localStorage.removeItem('token');
        return <Redirect to={`${baseUrl}admin/sign-in`} />;
      }
      return (
        <Authentication>
          <Component {...this.props} />
       </Authentication>
      );
    }
  };

export default withAuthentication;
